import { setCookieValue, getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';
import {
    CookieConsentCookie,
    CookieConsentTypeMode
} from '../modules/app/webComponents/CookieConsentDialog.types';

export async function getGoogleAnalyticsSessionId(): Promise<string | null> {
    return getGoogleAnalyticsValue('session_id');
}

export async function getGoogleAnalyticsClientId(): Promise<string | null> {
    return getGoogleAnalyticsValue('client_id');
}

export async function getValueFromGtag(
    googleTrackingId: string,
    value: string
): Promise<string | null> {
    const gtagPromise = await new Promise((resolve) => {
        const timeout = setTimeout(() => {
            resolve(null);
        }, 2000);

        window.gtag('get', googleTrackingId, value, (id) => {
            clearTimeout(timeout);
            resolve(id);
        });
    });

    return (await gtagPromise) as string;
}

export async function getGoogleAnalyticsValue(value: string): Promise<string | null> {
    const googleTrackingId: string | undefined = document.documentElement.dataset.gaTrackingId;
    const cookieConsentData: string | null = getCookieValue(CookieConsentCookie.NAME);

    if (!window.gtag || !googleTrackingId || !cookieConsentData) {
        return Promise.resolve(null);
    }

    let consentCookieValue: Record<string, unknown> = {};
    try {
        const raw = getCookieValue(CookieConsentCookie.NAME);
        consentCookieValue = raw ? JSON.parse(decodeURIComponent(raw)) : {};
    } catch {
        consentCookieValue = {};
    }

    if (
        'analytics_storage' in consentCookieValue &&
        consentCookieValue.analytics_storage === CookieConsentTypeMode.DENIED
    ) {
        return Promise.resolve(null);
    }

    const returnValue = await getValueFromGtag(googleTrackingId, value);

    if (typeof returnValue !== 'string') {
        return Promise.resolve(null);
    }

    setCookieValue(`ga_${value}`, returnValue);

    return returnValue;
}
